<script setup lang="ts">
import type { DynamicToolUIPart, ToolUIPart } from 'ai'
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { cn } from '../utils'

type ToolPart = ToolUIPart | DynamicToolUIPart

interface Props {
  input: ToolPart['input']
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()

const formattedInput = computed(() => {
  return JSON.stringify(props.input, null, 2)
})
</script>

<template>
  <div
    :class="cn('space-y-2 overflow-hidden p-4', props.class)"
    v-bind="$attrs"
  >
    <h4
      class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400"
    >
      Parameters
    </h4>
    <pre
      class="max-h-64 overflow-auto rounded-md bg-gray-50 p-3 text-xs text-gray-900 dark:bg-white/5 dark:text-gray-100"
    ><code>{{ formattedInput }}</code></pre>
  </div>
</template>
